import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LOGIN_PATH } from '~/constants';
import { useAuth } from '~/providers/AuthProvider';

export const RequireAuth: FC = () => {
  const { token } = useAuth();
  return token ? <Outlet /> : <Navigate to={LOGIN_PATH} replace />;
};
